import type { TitleEntity } from "~/src/api";
import { type QueryClient, useQuery } from "@tanstack/vue-query";
import { natSortNulls } from "~/src/reader/utils";

export const getReaderTitle = (
  queryClient: () => QueryClient,
  titleId: MaybeRef<string | undefined | null>,
  auth?: AuthFunction,
) => {
  return useQuery(
    {
      ...useTitleGet(
        computed(() => unref(titleId) ?? ""),
        ["organization", "cover_art", "tag"],
        auth,
      ),
      placeholderData: () => {
        const cached = getSingleEntityFromCache(
          queryClient().getQueryCache(),
          "title",
          unref(titleId) ?? "",
        ) as TitleEntity | undefined;
        if (cached) {
          return cached;
        }
      },
    },
    queryClient(),
  );
};

export const getReaderTitleChapters = (
  queryClient: () => QueryClient,
  titleId: MaybeRef<string | undefined | null>,
) => {
  return useQuery(
    {
      ...useTitleGroupedChapters(computed(() => unref(titleId) ?? "")),
      select: (data) => ({
        ...data,
        attributes: {
          ...data.attributes,
          // this is here to ensure order consistency
          list: data.attributes.list
            .map((vol) => ({
              ...vol,
              chapters: vol.chapters.sort(
                ({ chapter: chA }, { chapter: chB }) => natSortNulls(chA, chB),
              ),
            }))
            .sort(({ volume: volumeA }, { volume: volumeB }) =>
              natSortNulls(volumeA, volumeB),
            ),
        },
      }),
    },
    queryClient(),
  );
};
